import React from 'react'
import { Button, Modal } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

interface RedirectionModalProp {
    isOpen: boolean;
    onClose: () => void;
    data: any;
}

const RedirectionModal: React.FC<RedirectionModalProp> = ({ isOpen, onClose, data }) => {
    const navigate = useNavigate();

    const onConfirm = () => {
        navigate('/interStore-transfer', { state: data })
    }
    return (
        <>
            <Modal show={isOpen} onHide={onClose} centered backdrop='static'>
                <Modal.Header closeButton>
                    <Modal.Title>Confirm Action</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <h6>
                        {data?.message ?? ''}
                    </h6>
                </Modal.Body>
                <Modal.Footer>
                    <Button className="btn add-btn" onClick={onClose}>
                        Cancel
                    </Button>
                    <Button className="btn submit-btn" onClick={onConfirm}>
                        Procced
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default RedirectionModal
